// extracted by mini-css-extract-plugin
export default {"view_shipping_address_link":"RegistrantLocation-styles__view_shipping_address_link__b2kkq","location_copy_container":"RegistrantLocation-styles__location_copy_container__Tby52"};